<template>
  <modal name="admin-management-modal" class="admin-management-modal"
         :width="'400px'"
         :height="'auto'"
         @before-close="handlerBeforeClose"
         @before-open="handlerBeforeOpen"
         @opened="handlerOpened"
  >
  <admin-write-component :adminType="adminType" :adminKey="adminKey"></admin-write-component>
  </modal>
</template>

<script>
import AdminWriteComponent from "@/components/admin/AdminWriteComponent";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
export default {
  name: "AdminManagementModal",
  mixins: [alertMixins],
  components: {
    AdminWriteComponent
  },
  inject: ['changeLoading'],
  props: {
  },
  provide() {
            return {
              closePopup: this.close,
            }
        },
  data() {
    return {
      adminKey:0,
      adminType:'adminCreate',
    }
  },
  beforeRouterEnter() {},
  created() {

  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    handlerBeforeOpen(event) {
      if (event.params.hasOwnProperty('adminType')) { // 등록시
        this.adminType = event.params.adminType;
        if(event.params.hasOwnProperty('adminKey')){
          this.adminKey = event.params.adminKey;
        }else {
          this.adminKey = 0;
        }
      } else { 
        this.close();
      }
    },
    handlerOpened() {
    },
    handlerBeforeClose() {
    },
    close(){
      this.$modal.hide('admin-management-modal');
    },
    afterFunc(){
      this.createAlert({
        content: '저장되었습니다.',
        hide: () => {
          EventBus.$emit('getList')
          this.close();
        }
      })
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
